import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { detectPatterns } from "../utils/timelinePatterns";
import { formatTimelinePeriod } from "../utils/timelineFormatters";

const PatternPanel = ({ t, dataPoints }) => {
  const patterns = useMemo(() => detectPatterns(dataPoints), [dataPoints]);

  return (
    <div className="mat-pattern-panel anomaly-chart-card">
      <div className="chart-card-header">
        <h6>{t("MetricAnomalyTimeline.patternPanel.label")}</h6>
      </div>
      <div className="chart-card-body">
        {patterns.length === 0 ? (
          <p className="mat-panel-empty">{t("MetricAnomalyTimeline.noPatterns.label")}</p>
        ) : (
          <div className="mat-pattern-list">
            {patterns.map((pattern) => (
              <div key={pattern.id} className="mat-pattern-card">
                <h6 className="mat-pattern-title">{t(pattern.titleKey)}</h6>
                <p className="mat-pattern-explanation">{t(pattern.explanationKey)}</p>
                <p className="mat-pattern-periods">
                  <strong>{t("MetricAnomalyTimeline.affectedPeriods.label")}:</strong>{" "}
                  {pattern.periods.map(formatTimelinePeriod).join(", ")}
                </p>
                <p className="mat-pattern-action">{t(pattern.actionKey)}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(PatternPanel);
